<template>
  <event-cards :events="events" :title="title"/>
</template>

<script>
import EventCards from '@/components/EventCards'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    EventCards,
  },
  data: () => ({
    events: [
      {
        to: {name: 'retreat-catering'},
        image: {
          url: require('@/assets/images/retreat-catering-banner2.jpg?vuetify-preload')
        },
        title: 'Retreat Catering',
      },
      {
        to: {name: 'event-catering'},
        image: {
          url: require('@/assets/images/event-catering-banner2.jpg?vuetify-preload')
        },
        title: 'Event Catering',
      },
      {
        to: {name: 'cooking-classes'},
        image: {
          url: require('@/assets/images/cooking-classes-banner3.jpg?vuetify-preload')
        },
        title: 'Cooking Classes'
      },
      {
        to: {name: 'personal-chef'},
        image: {
          url: require('@/assets/images/personal-chef-banner1.jpg?vuetify-preload')
        },
        title: 'Personal Chef'
      },
      {
        to: {name: 'collaborations'},
        image: {
          url: require('@/assets/images/collaborations.jpg?vuetify-preload')
        },
        position: 'center center',
        title: 'Collaborations'
      },
      /**
       * Archived Services
       */
      // {
      //   to: {name: 'home-deliveries'},
      //   image: {
      //     url: require('@/assets/images/deliveries.jpg?vuetify-preload')
      //   },
      //   title: 'Home Deliveries',
      //   disabled: true,
      // }
    ],
    title: 'Work With Me',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .title(this.title)
      .build()
  }
}
</script>
